import * as THREE from 'three';
import './css/ui.scss';
import './css/pageGlobal.scss';

import './script/pageGlobal.js';
import './script/cursor.js';
import './script/page2.js';
import './script/page3.js';
import './script/page4.js';
import './script/bg.js';
import './script/ui.js';
import './script/intro.js';
import { time } from 'three/tsl';
import { LAppDelegate } from './lappdelegate';


const logContainer = document.getElementById("logContainer");
const progress = document.getElementById("progress");
const progressBar = document.getElementById("progressBar");
let progressValue = 0;

function logToPage(message) { 
    if (logContainer) {
        logContainer.textContent = message; // écrase le message précédent
    }
}
function IsCharged() {
  console.log(logContainer.textContent);
  return logContainer.textContent == "Charged";
}

const observer = new MutationObserver((mutations) => {
    progressValue ++;
    progress.style.width = progressValue/0.17 + "%";
    if (logContainer.textContent.trim().toLowerCase() === "charged") {
      logContainer.style.display = "none";
      progressBar.style.display = "none";
      animateText('mu', 40, 0, false);
      animateText('mn', 40, 500, false);
      animateText('clic', 40, 2000, true);
    }
});

observer.observe(logContainer, {
  childList: true,       // détecte les ajouts/suppressions d’éléments enfants
  characterData: true,   // détecte les changements dans le texte
  subtree: true          // observe aussi les nœuds enfants
});




// rendez la fonction accessible globalement
window.logToPage = logToPage;
window.ischarged = IsCharged;
logToPage("Scripts...");


console.log("main.js loaded");
const manager = new THREE.LoadingManager();

manager.onStart = function ( url, itemsLoaded, itemsTotal ) {
    console.log( 'Commence à charger : ' + url );
};

manager.onLoad = function ( ) {
    console.log( 'Tous les fichiers sont chargés !' );
    // Ici tu peux cacher ta barre de chargement
};

manager.onProgress = function ( url, itemsLoaded, itemsTotal ) {
    console.log( 'Chargement en cours : ' + itemsLoaded + ' / ' + itemsTotal );
    logToPage(`Items Three.Js : ${itemsLoaded} / ${itemsTotal}`);
    // Ici tu peux mettre à jour la barre de progression
};


LAppDelegate.getInstance().initialize();

if (window.matchMedia("(pointer: coarse)").matches) {
  // Si l'utilisateur a un écran tactile
  document.querySelectorAll('.mouse-only').forEach(element => {
    element.style.display = 'none';  // Cache les éléments "mouse-only"
  });
}


// 1. Initialisation de la scène
const scene = new THREE.Scene();

const textureLoader = new THREE.TextureLoader(manager);
scene.background = null; // Pas de fond pour la scène Three.js


const camera = new THREE.PerspectiveCamera(60, window.innerWidth / window.innerHeight, 0.1, 1000);
camera.position.set(0, 8, 3); // gauche - bas - hauteur
camera.rotation.set(-1.1, 0, 2.8); // bas - gauche - trigo

const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
//  renderer.dispose();
renderer.setPixelRatio(0.8 * window.devicePixelRatio);
renderer.setSize(window.innerWidth, window.innerHeight);

console.log("CSS Width:", window.innerWidth);
console.log("CSS Height:", window.innerHeight);
console.log("DPR:", window.devicePixelRatio);
console.log("Appareil Width:", window.screen.width);
console.log("Appareil Height:", window.screen.height);

document.body.appendChild(renderer.domElement);












// 2. Créer les cercles avec des tailles et textures différentes
const createCircle = (size, texture) => {
  const geometry = new THREE.PlaneGeometry(size, size);
  const material = new THREE.MeshBasicMaterial({
    map: texture,
    transparent: true, // Permet la transparence
    opacity: 0.65, // Définir l'opacité (alpha)
    side: THREE.DoubleSide,
    blending: THREE.AdditiveBlending, // Ajouter l'addition des couleurs
    depthWrite: true, // Désactiver l'écriture dans le buffer de profondeur
    depthTest: false // Désactiver le test de profondeur pour les objets transparents
  });

  const plane = new THREE.Mesh(geometry, material);
  plane.position.set(0, 0, 0); // Position au centre
  plane.rotation.set(0, 0, 0); // Inclinaison identique

  if (texture == texture5) {
    plane.position.set(-3, 6, 0); // Position spécifique pour texture5
    plane.rotation.set(0, 0, 0); // Inclinaison identique
  }

  return plane;
};

// 3. Charger les textures
const texture1 = textureLoader.load('./img/circle1.png');
const texture2 = textureLoader.load('./img/circle2.png');
const texture3 = textureLoader.load('./img/circle3.png');
const texture4 = textureLoader.load('./img/circle4.png');
const texture5 = textureLoader.load('./img/circle5.png');

// Créer 3 cercles avec des tailles et textures différentes
const circle1 = createCircle(6, texture1); // Premier cercle avec texture1
const circle2 = createCircle(12, texture2); // Deuxième cercle avec texture2
const circle3 = createCircle(16, texture3); // Troisième cercle avec texture3
const circle4 = createCircle(10, texture4); // Troisième cercle avec texture3
const circle5 = createCircle(4, texture5); // Troisième cercle avec texture3

// Ajouter les cercles à la scène
scene.add(circle1);
scene.add(circle2);
scene.add(circle3);
scene.add(circle4);
scene.add(circle5);


















// 4. Créer un système de particules 3D
const particleCount = 9000; // Nombre de particules
const particleMaterial = new THREE.PointsMaterial({
  size: 0.06, 
  transparent: true,
  sizeAttenuation: true,
  opacity: 0.7, // Opacité initiale
  map: new THREE.TextureLoader(manager).load('./img/particle.png'),
  blending: THREE.AdditiveBlending,
  depthWrite: false,
  vertexColors: true,
});

// Créer une géométrie de particules en 3D
const particleGeometry = new THREE.BufferGeometry();
const positions = new Float32Array(particleCount * 3);
const colors = new Float32Array(particleCount * 3); // Tableau pour les couleurs

// Fonction pour générer un nombre pseudo-aléatoire avec un seed
function random(seed) {
    const x = Math.sin(seed * 10000) * seed;
    return x - Math.floor(x);
}
function random2(seed) {
    const x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
}

// Ajouter un facteur de randomisation dans la spirale
for (let i = 0; i < particleCount; i++) {
  const randomFactor = random(i + 42);

  const angle = (i * 3.14) + randomFactor * 0.5;
  const radius = (Math.sqrt(i) * 0.08) + randomFactor * 0.5;

  const x = radius * Math.cos(angle) + random2(i + 42) / 2;
  const y = radius * Math.sin(angle) + random2(i + 42) / 2;
  const z = (0 - Math.sqrt(i) / 60) * random2(i + 42);

  positions.set([x, y, z], i * 3);

  // 🔥 Générer une teinte entre 0.6 (bleu) et 0.9 (rose)
  const hue = 0.3 + 0.5 + Math.sin(i / 1000) / 2 * 0.3;
  const saturation = 1.0; // Couleur bien vive
  const lightness = 0.55 + (0.5 + Math.sin(i * 2 / 1000) / 2) * 0.3; // Légèrement lumineux

  const color = new THREE.Color().setHSL(hue, saturation, lightness);

  colors.set([color.r, color.g, color.b], i * 3);
}

// Ajouter les attributs de position, couleur et taille à la géométrie
particleGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
particleGeometry.setAttribute('color', new THREE.BufferAttribute(colors, 3));

// Créer un objet Points avec la géométrie et le matériau
const particles = new THREE.Points(particleGeometry, particleMaterial);

// Ajouter les particules à la scène
scene.add(particles);










let particles3;
let particleGeometry3;
let positions3;
let colors3; // Tableau pour les couleurs
let isparticleready = false;

// Charger le fichier JSON
fetch("./global/mesPositions.json")
  .then(response => response.text())  // Lire le fichier en texte brut
  .then(text => {

    const positionsData = JSON.parse(text).filter((_, index) => {
      const cycleIndex = index % 3;
      return cycleIndex < 3; // On garde si c'est dans les 3 premières de chaque cycle
    });


    // Nombre de particules (basé sur ton tableau)
    const particleCount3 = positionsData.length / 3; 

    const particleMaterial3 = new THREE.PointsMaterial({
      size: 0.06, 
      transparent: true,
      sizeAttenuation: true,
      opacity: 0.6, // Opacité initiale
      map: new THREE.TextureLoader(manager).load('./img/particle.png'),
      blending: THREE.AdditiveBlending,
      depthWrite: false,
      vertexColors: true,
    });

    // Créer une géométrie de particules en 3D
    particleGeometry3 = new THREE.BufferGeometry();
    positions3 = new Float32Array(particleCount3 * 3);
    colors3 = new Float32Array(particleCount3 * 3); // Tableau pour les couleurs

    // Remplir le tableau positions3 avec les positions venant du tableau JSON
    for (let i = 0; i < particleCount3; i++) {
      // Prendre les valeurs (x, y, z) depuis positionsData
      const x3 = positionsData[i * 3];
      const y3 = positionsData[i * 3 + 1];
      const z3 = positionsData[i * 3 + 2];

      positions3.set([x3, y3, z3], i * 3);

      // 🔥 Générer une teinte entre 0.6 (bleu) et 0.9 (rose)
      const hue3 = 0.3 + 0.5 + Math.sin(i / 1000) / 2 * 0.3;
      const saturation3 = 1.0; // Couleur bien vive
      const lightness3 = 0.55 + (0.5 + Math.sin(i * 2 / 1000) / 2) * 0.3; // Légèrement lumineux

      const color3 = new THREE.Color().setHSL(hue3, saturation3, lightness3);

      colors3.set([color3.r, color3.g, color3.b], i * 3);
    }

    // Ajouter les attributs de position, couleur et taille à la géométrie
    particleGeometry3.setAttribute('position', new THREE.BufferAttribute(positions3, 3));
    particleGeometry3.setAttribute('color', new THREE.BufferAttribute(colors3, 3));

    // Créer un objet Points avec la géométrie et le matériau
    particles3 = new THREE.Points(particleGeometry3, particleMaterial3);

    // Ajouter les particules à la scène
    scene.add(particles3);
    
    initialPositions3_chepatropquand();
    isparticleready = true;
  })
  .catch(error => console.error("Erreur lors du chargement du JSON :", error));















let points = [
  new THREE.Vector3(1400, 1400, 0),
  new THREE.Vector3(0, 0, 0),
  new THREE.Vector3(-1400, 1400, 0),
  new THREE.Vector3(0, 0, 0),
  new THREE.Vector3(0, 0, 2000),
  new THREE.Vector3(0, 0, 0),
  new THREE.Vector3(-1400, -1400, 0),
  new THREE.Vector3(0, 0, 0),
  new THREE.Vector3(1400, -1400, 0),
  new THREE.Vector3(0, 0, 0),
  new THREE.Vector3(0, 0, -2000),
  new THREE.Vector3(0, 0, 0)
];
// Appliquer la rotation à chaque point
const geometry = new THREE.BufferGeometry().setFromPoints(points);
const material = new THREE.LineBasicMaterial({ color: 0x776677 });
const line = new THREE.Line(geometry, material);
scene.add(line);










let launchcircle1Z=0;
let launchcircle2Z=0;
let launchcircle3Z=0;
let launchcircle4Z=0;
let launchcircle5Z=0;

let launchlines=0;
let scrollFluidspeed=0;
let scrollFluidspeedFactor=0;

let launch = false;

export function launch3D(){

  camera.rotation.x = -1.1 + (1 + Math.sin(rotationTime)) * 0.05 + 0.5;
  camera.rotation.z = 2.8 + (1 + Math.cos(rotationTime)) * 0.05 + 0.2;
  camera.position.y = 8 + (1 + Math.sin(rotationTime)) * 0.05 + 2;
  camera.position.z = 3 + (1 + Math.cos(rotationTime)) * 0.05 + 20;

  scrollFluid=-10;
  scrollFluidspeedFactor=2;

  launchcircle1Z=5;
  launchcircle2Z=3;
  launchcircle3Z=9;
  launchcircle4Z=8;
  launchcircle5Z=-3;

  launchlines=500;

  setTimeout(() => {
    launch = true;
  }, "1000");
}
window.launch2 = launch3D;













// 1. Créer un cercle cliquable en 2D orienté vers la caméra
const createClickableCircle = (size, texture, opacity) => {
  const material = new THREE.SpriteMaterial({
    map: texture,
    transparent: true,
    opacity: opacity,
    blending: THREE.NormalBlending,
    depthTest: false,
    depthWrite: true, // Désactiver l'écriture dans le buffer de profondeur
  });
  
  const sprite = new THREE.Sprite(material);
  sprite.scale.set(size, size, 1); // Définir la taille du cercle
  sprite.position.set(0,0,0); // Position aléatoire dans la scène

  return sprite;

}; 

// 2. Charger une texture pour le cercle cliquable
const clickableCircleTextureC = textureLoader.load('./img/circleC.png');
const clickableCircleTextureB = textureLoader.load('./img/circleB2.png');
const clickableCircleTextureB2 = textureLoader.load('./img/circleB2.png');
const clickableCircleTextureB3 = textureLoader.load('./img/circleB3.png');
const clickableCircleTextureB4 = textureLoader.load('./img/circleB4.png');
const clickableCircleTextureB5 = textureLoader.load('/img/circleB5.png');

// 3. Créer et ajouter un cercle cliquable à la scène
const clickableCircle = createClickableCircle(1.5, clickableCircleTextureC, 0.8);
scene.add(clickableCircle);
const clickableCircle2 = createClickableCircle(1, clickableCircleTextureB2, 1);
scene.add(clickableCircle2);
const clickableCircle3 = createClickableCircle(1, clickableCircleTextureB3, 1);
scene.add(clickableCircle3);
const clickableCircle4 = createClickableCircle(1, clickableCircleTextureB4, 1);
scene.add(clickableCircle4);


const clickableCircle5 = createClickableCircle(1, clickableCircleTextureB5, 1);
scene.add(clickableCircle5);



// 4. Mettre à jour l'orientation du cercle cliquable vers la caméra
function updateClickableCircles() {
  clickableCircle.lookAt(camera.position); // Assurez-vous que le cercle regarde toujours la caméra
  clickableCircle2.lookAt(camera.position); // Assurez-vous que le cercle regarde toujours la caméra
  clickableCircle3.lookAt(camera.position);
  clickableCircle4.lookAt(camera.position);
  clickableCircle5.lookAt(camera.position);
}

    







let target = new THREE.Vector3(0, 0, 0); // Point vers lequel la caméra doit regarder
let rotationSpeed = 0.1; // Vitesse de l'interpolation

// Fonction pour ajuster la rotation de la caméra progressivement
function updateCameraRotation() {
    // Calculer la direction vers le point cible
    let direction = new THREE.Vector3().subVectors(target, camera.position).normalize();

    // Calculer les rotations nécessaires pour que la caméra regarde vers la cible
    let targetRotation = new THREE.Quaternion().setFromUnitVectors(camera.getWorldDirection(new THREE.Vector3(0, 0, -1)), direction);

    // Interpolation de la rotation
    camera.rotation.setFromQuaternion(camera.quaternion.slerp(targetRotation, rotationSpeed));

    // La caméra regarde toujours vers la cible après l'interpolation
    camera.lookAt(target);
}





























let canAnimate = true;

function findPos(angle, distance) {
  const x = distance * Math.cos(angle);
  const y = distance * Math.sin(angle);
  const z = 0.2; // Valeur fixe pour z

  return new THREE.Vector3(x, y, z);
}

let page = 1;

let angleCircleB2 = 0* 2*Math.PI/3;
let distanceCircleB2 = 0;
let angleCircleB3 = 1* 2*Math.PI/3;
let distanceCircleB3 = 0;
let angleCircleB4 = 2* 2*Math.PI/3;
let distanceCircleB4 = 0;
let angleCircleB5 = 3* 2*Math.PI/4;
let distanceCircleB5 = 0;

let actualSizeHoverB2 = 1;
let actualSizeHoverB3 = 1;
let actualSizeHoverB4 = 1;
let actualSizeHoverB5 = 1;

// 5. Animation des particules et rotation des cercles
let rotationTime = 0;
let scroll = 0;
let scrollFluid = 0;
let scrollFluidOld = 0;
let scrollFluidDif = 0;

let lastTime = 0;
const fps = 60;
const interval = 1000 / fps; // 16.67ms pour 60FPS
let vitesse = 0;
let _direction=1;

let click = false;
let firstTime = true;
let opacityGoal = 0.8;

let focal = 15;

let lastScrollFluidClock =0;

function animate(time) {
  requestAnimationFrame(animate);
  if (firstTime) {
        console.log("Première itération !");
        firstTime = false; // auto-disable
    }

  if (canAnimate) {
    
  
    updateClickableCircles();

    const deltaTime = time - lastTime;
    
    if (deltaTime >= interval) {
      

      if(mouse_click >0){mouse_click /= 1.1}

      launchcircle1Z/=1.03;
      launchcircle2Z/=1.03;
      launchcircle3Z/=1.03;
      launchcircle4Z/=1.03;
      launchcircle5Z/=1.03;

      circle1.position.z = launchcircle1Z;
      circle1.scale.set(1-launchcircle1Z/5, 1-launchcircle1Z/5);
      circle2.position.z = launchcircle2Z;
      circle2.scale.set(1-launchcircle2Z/5, 1-launchcircle2Z/5);
      circle3.position.z = -launchcircle3Z;
      circle3.scale.set(1-launchcircle3Z/5, 1-launchcircle3Z/5);
      circle4.position.z = launchcircle4Z;
      circle4.scale.set(1-launchcircle3Z/5, 1-launchcircle3Z/5);
      circle5.position.z = launchcircle5Z;
      circle5.scale.set(1-launchcircle1Z/5, 1-launchcircle1Z/5);

      launchlines/=1.1;
      scrollFluidspeedFactor /=1.001
      scrollFluidspeed =1 +scrollFluidspeedFactor;

      points[0] = new THREE.Vector3(points[0].x, points[0].y, launchlines);
      points[2] = new THREE.Vector3(points[2].x, points[2].y, launchlines);
      points[6] = new THREE.Vector3(points[6].x, points[6].y, launchlines);
      points[8] = new THREE.Vector3(points[8].x, points[8].y, launchlines);
      geometry.setFromPoints(points);

      // Mettre à jour lastTime pour la prochaine frame
      lastTime = time - (deltaTime % interval);
      vitesse = 0.6;

      // Logique de l'animation
      scrollFluid += (scroll - scrollFluid) / (20*scrollFluidspeed);
      scrollFluidDif = scrollFluid - scrollFluidOld;
      
      if (lastScrollFluidClock - scrollFluid > 1.5 && launch && launchcircle1Z < 0.2 || lastScrollFluidClock - scrollFluid < -1.5 && launch && launchcircle1Z < 0.2 ) {
        lastScrollFluidClock = scrollFluid;
        //clock();
      }


      circle1.position.z = Math.abs(scrollFluidDif);

      // Faire tourner les cercles
      circle1.rotation.z += (0.002* _direction + scrollFluidDif)*vitesse;
      circle2.rotation.z -= (0.0018* _direction + scrollFluidDif)*vitesse;
      circle3.rotation.z += (0.0011* _direction + scrollFluidDif)*vitesse;
      circle4.rotation.z -= (0.0006* _direction + scrollFluidDif / 2)*vitesse;
      circle5.rotation.z += (0.003* _direction + scrollFluidDif)*vitesse;

      angleCircleB2 += (0.0005* _direction + scrollFluidDif/2)*vitesse;
      distanceCircleB2 = 4 + (1 + Math.sin(rotationTime)) * 0.7;
      angleCircleB3 += (0.0005* _direction + scrollFluidDif/2)*vitesse;
      distanceCircleB3 = 4 + (1 + Math.sin(rotationTime)) * 0.7;
      angleCircleB4 += (0.0005* _direction + scrollFluidDif/2)*vitesse;
      distanceCircleB4 = 4 + (1 + Math.sin(rotationTime)) * 0.7;
      angleCircleB5 += (0.0005* _direction + scrollFluidDif/2)*vitesse;
      distanceCircleB5 = 4 + (1 + Math.sin(rotationTime)) * 0.7;

      clickableCircle2.position.x = findPos(angleCircleB2, distanceCircleB2).x;
      clickableCircle3.position.x = findPos(angleCircleB3, distanceCircleB3).x;
      clickableCircle4.position.x = findPos(angleCircleB4, distanceCircleB4).x;
      clickableCircle5.position.x = 0;
      clickableCircle2.position.y = findPos(angleCircleB2, distanceCircleB2).y;
      clickableCircle3.position.y = findPos(angleCircleB3, distanceCircleB3).y;
      clickableCircle4.position.y = findPos(angleCircleB4, distanceCircleB4).y;
      clickableCircle5.position.y = 0;
      clickableCircle2.position.z = findPos(angleCircleB2, distanceCircleB2).z;
      clickableCircle3.position.z = findPos(angleCircleB3, distanceCircleB3).z;
      clickableCircle4.position.z = findPos(angleCircleB4, distanceCircleB4).z;
      clickableCircle5.position.z = 0;

      // Faire tourner les particules autour du cercle (en 3D)
      particles.rotation.z += (0.0005* _direction + scrollFluidDif / 10)*vitesse;
      if (isparticleready) {
        particles3.rotation.z += (0.0011* _direction + scrollFluidDif / 10)*vitesse*1.2;
      }
      
      
      rotationTime += 0.009 * vitesse;
      
      let camGoalRotx;
      let camGoalRoty;
      let camGoalRotz;
      let camGoalPosx;
      let camGoalPosy;
      let camGoalPosz;

      let focalGoal;

      if (page === 1) {
        camGoalRotx = -1.1 + (1 + Math.sin(rotationTime)) * 0.05;
        camGoalRoty = 0;
        camGoalRotz = 2.8 + (1 + Math.cos(rotationTime)) * 0.05;
        camGoalPosx = 0;
        camGoalPosy = 8 + (1 + Math.sin(rotationTime)) * 0.05;
        camGoalPosz = 3 + (1 + Math.cos(rotationTime)) * 0.05;

        opacityGoal = (opacityGoal * 19 + 0.8) / 20 ;
        opacityGoal = (opacityGoal * 19 + 0.8) / 20 ;
        opacityGoal = (opacityGoal * 19 + 0.8) / 20 ;
        opacityGoal = (opacityGoal * 19 + 0.8) / 20 ;
      }else if (page === 2) {
        opacityGoal /= 1.05;
        
        camGoalRotx = -0.5;
        camGoalRoty = 1;
        camGoalRotz = 2.5;
        camGoalPosx = 6;
        camGoalPosy = 3;
        camGoalPosz = 2.5;
      }else if (page === 3) {
        opacityGoal /= 1.05;
        
        camGoalRotx = -1.2;
        camGoalRoty = 0;
        camGoalRotz = 2.5;
        camGoalPosx = -1;
        camGoalPosy = 10;
        camGoalPosz = 1.8;
      }else if (page === 4) {
        opacityGoal /= 1.05;
        
        camGoalRotx = -0.9;
        camGoalRoty = 0.5;
        camGoalRotz = 3;
        camGoalPosx = 6;
        camGoalPosy = 2;
        camGoalPosz = 1.3;
      }else if (page === 5) {

        opacityGoal /= 1.05;
        
        camGoalPosx = 0 ;
        camGoalPosy = 0.01 ;
        camGoalPosz = 0 ;
        
        camGoalRotx = -1;
        camGoalRoty = 0;
        camGoalRotz = 3.3;

        
      }
      if(page === 5){
        focalGoal = 1;
      }else{
        focalGoal = 15;
      }

      focal = (focalGoal + focal*29)/30;
      camera.setFocalLength((focal));
      camera.zoom = 2-focal/15;
      camera.rotation.x = (camGoalRotx + camera.rotation.x*29)/30;
      camera.rotation.y = (camGoalRoty + camera.rotation.y*29)/30;
      camera.rotation.z = (camGoalRotz + camera.rotation.z*29)/30;
      
      camera.position.x = (camGoalPosx + camera.position.x*29)/30;
      camera.position.y = (camGoalPosy + camera.position.y*29)/30;
      camera.position.z = (camGoalPosz + camera.position.z*29)/30;

      scrollFluidOld = scrollFluid;
    
      raycaster.camera = camera;
      // Mettre à jour le raycaster pour chaque frame avec la position de la souris
      raycaster.ray.origin.setFromMatrixPosition(camera.matrixWorld); // Origine du rayon : la caméra
      raycaster.ray.direction.set(mouse.x, mouse.y, 0.5).unproject(camera).sub(raycaster.ray.origin).normalize(); // Direction du rayon
      
      distortParticles(); // Appliquer l'effet
      if(isparticleready){distortParticles3()};

      // clickableCircle2
      const intersects2 = raycaster.intersectObject(clickableCircle2);
      if (intersects2.length > 0) {
        actualSizeHoverB2 = (actualSizeHoverB2 * 19 + 1.2) / 20;
      } else {
        actualSizeHoverB2 = (actualSizeHoverB2 * 19 + 1) / 20;
      }
      clickableCircle2.scale.set(actualSizeHoverB2, actualSizeHoverB2, 1);
      clickableCircle2.material.opacity = opacityGoal *( actualSizeHoverB2);

      // clickableCircle3
      const intersects3 = raycaster.intersectObject(clickableCircle3);
      if (intersects3.length > 0) {
        actualSizeHoverB3 = (actualSizeHoverB3 * 19 + 1.2) / 20;
      } else {
        actualSizeHoverB3 = (actualSizeHoverB3 * 19 + 1) / 20;
      }
      clickableCircle3.scale.set(actualSizeHoverB3, actualSizeHoverB3, 1);
      clickableCircle3.material.opacity = opacityGoal *( actualSizeHoverB3);

      // clickableCircle4
      const intersects4 = raycaster.intersectObject(clickableCircle4);
      if (intersects4.length > 0) {
        actualSizeHoverB4 = (actualSizeHoverB4 * 19 + 1.2) / 20;
      } else {
        actualSizeHoverB4 = (actualSizeHoverB4 * 19 + 1) / 20;
      }
      clickableCircle4.scale.set(actualSizeHoverB4, actualSizeHoverB4, 1);
      clickableCircle4.material.opacity = opacityGoal *( actualSizeHoverB4);

      
      // clickableCircle5
      const intersects5 = raycaster.intersectObject(clickableCircle5);
      if (intersects5.length > 0) {
        actualSizeHoverB5 = (actualSizeHoverB5 * 19 + 1.4) / 20;
      } else {
        actualSizeHoverB5 = (actualSizeHoverB5 * 19 + 1) / 20;
      }
      clickableCircle5.scale.set(actualSizeHoverB5*1.3, actualSizeHoverB5*1.3, 1);
      clickableCircle5.material.opacity = 1; //opacityGoal *( actualSizeHoverB5);
        

      if (click) {
        click = false
        if (intersects2.length > 0) {
          clickSurB(2);
        }else
        if (intersects3.length > 0) {
          clickSurB(3);
        }else
        if (intersects4.length > 0) {
          clickSurB(4);
        }
        if (intersects5.length > 0) {
          clickSurB(5);
        }
      }
      
      renderer.render(scene, camera);
      firstTime = false;
    }
  }
}
























const clock1 = document.getElementById('clock1');
const clock2 = document.getElementById('clock2');
const clock3 = document.getElementById('clock3');
const clock4 = document.getElementById('clock4');
const clock5 = document.getElementById('clock5');
let clocksValue = 1;

window.addEventListener('wheel', onWheel);
function onWheel(event) {
  if (canAnimate) {
    scroll += event.deltaY/100;
    _direction = Math.sign(event.deltaY); 
  }
}

function clock(){
  
  
  if       (clocksValue===1) {
    clock1.currentTime = 0;
    clock1.play();
    clocksValue ++;
  }else if (clocksValue===2) {
    clock2.currentTime = 0;
    clock2.play();
    clocksValue ++;
  }else if (clocksValue===3) {
    clock3.currentTime = 0;
    clock3.play();
    clocksValue ++;
  }else if (clocksValue===4) {
    clock4.currentTime = 0;
    clock4.play();
    clocksValue ++;
  }else if (clocksValue===5) {
    clock5.currentTime = 0;
    clock5.play();
    clocksValue = 1;
  }

  
}

// Raycaster et souris
const raycaster = new THREE.Raycaster();
const mouse = new THREE.Vector2();

// Événement de la souris pour suivre la position
document.addEventListener('mousemove', (event) => {
  // Calculer la position de la souris en coordonnées normalisées (-1 à +1)
  mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
  mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
});

document.addEventListener('click', (event) => {
  if (canAnimate) click = true;
});

document.addEventListener("touchmove", (event) => {
  event.preventDefault();
}, { passive: false });

let startY = 0;
let startX = 0;

document.addEventListener("touchstart", (event) => {
  startY = event.touches[0].clientY;
  startX = event.touches[0].clientX;
}, { passive: true });

document.addEventListener("touchmove", (event) => {
  let deltaY = startY - event.touches[0].clientY;
  let deltaX = startX - event.touches[0].clientX;
  
  // Mettre à jour les valeurs pour éviter un décalage trop fort
  startY = event.touches[0].clientY;
  startX = event.touches[0].clientX;

  // Simuler un scroll en fonction du mouvement du doigt
  scroll += deltaY/10 - deltaX/20; // Ajuste le facteur si le scroll est trop rapide
  _direction = Math.sign(deltaY + deltaX/2); 
});





let WWisDragging = false;
let WWstartX = 0;
let WWstartY = 0;
let WWdirection = 0;

document.addEventListener("mousedown", (event) => {
  WWisDragging = true;
  WWstartX = event.clientX;
  WWstartY = event.clientY;
});

document.addEventListener("mousemove", (event) => {
  if (!WWisDragging) return;

  let deltaY = WWstartY - event.clientY;
  let deltaX = WWstartX - event.clientX;

  WWstartY = event.clientY;
  WWstartX = event.clientX;

  scroll += deltaY / 30 - deltaX / 60;
  WWdirection = Math.sign(deltaY + deltaX / 2);

});

document.addEventListener("mouseup", () => {
  WWisDragging = false;
});














let menu = true;
const _click = document.getElementById('click');
gsap.set("#page2Bg", {
  opacity: 0,  // Valeur d'arrivée (l'élément disparaît)
});
gsap.set("#page3Bg", {
  opacity: 0,  // Valeur d'arrivée (l'élément disparaît)
});
gsap.set("#page4Bg", {
  opacity: 0,  // Valeur d'arrivée (l'élément disparaît)
});

gsap.set("#retourMenu", {
  y: -100,  // Valeur d'arrivée (l'élément disparaît)
});

let canClickCircles = true;
let timeoutCanAnimate;
  //animateText("retourMenu", 0, 0, false, 0, false);
function clickSurB(x){
  if (screen.width < screen.height) {
    alert("Pour une expérience complète, veuillez visiter ce site sur un ordinateur, ou attendez la version mobile !");
  }
  else{
    console.log(x + "clickSurB");
    if (launch && menu) {
      canClickCircles = false;
      //animateText("retourMenu", 10, 500, false, 1, false);
      gsap.to("#retourMenu", {
        y: 0,  // Valeur d'arrivée (l'élément disparaît)
        duration: 1,  // Durée de l'animation
        ease: "power2.Out"  // Courbe d'accélération
      });
      
      _click.currentTime = 0.2;
      _click.play();
      console.log(x);
      page = x;
      menu = false;
      if (x === 2) {
        window.page2Start();
      }
      if (x === 3) {
        window.page3Start();
      }
      if (x === 4) {
        window.page4Start();
      }
      if (x === 5) {
        window.pageGlobalStart();

        

        timeoutCanAnimate = setTimeout(() => {
          canAnimate = false;
        }, 1000);
      }

      
    }
  }
}

const backB = document.getElementById("retourMenu")
backB.addEventListener("click", () => {
    
    if (projet.style.zIndex > 9) {
      projetClose();
      return;
    }

  retourMenu();
});




document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {  // Vérifie si la touche appuyée est 'Escape'
    
    const elements = document.querySelectorAll(".upscale");
    for (const el of elements) {
      if (el.style.display === "flex") {
        el.style.display = "none";
        return;
      }
    }

    retourMenu();

  }
});


function retourMenu(){
  if(!menu){
    canAnimate = true;
    clearTimeout(timeoutCanAnimate);
    console.log("menu");
    window.pageGlobalEnd();
    
    _click.currentTime = 0.2;
      _click.play();
      gsap.to("#retourMenu", {
        y: -100,  // Valeur d'arrivée (l'élément disparaît)
        duration: 1,  // Durée de l'animation
        ease: "power2.inOut"  // Courbe d'accélération
    });


    gsap.to("#page2Bg", {
      opacity: 0,  // Valeur d'arrivée (l'élément disparaît)
      duration: 2,  // Durée de l'animation
      ease: "power2.inOut"  // Courbe d'accélération
    });
    window.page2End();

    gsap.to("#page3Bg", {
      opacity: 0,  // Valeur d'arrivée (l'élément disparaît)
      duration: 2,  // Durée de l'animation
      ease: "power2.inOut"  // Courbe d'accélération
    });
    window.page3End();

    gsap.to("#page4Bg", {
      opacity: 0,  // Valeur d'arrivée (l'élément disparaît)
      duration: 2,  // Durée de l'animation
      ease: "power2.inOut"  // Courbe d'accélération
    });
    window.page4End();
    page = 1;
    setTimeout(() => {
      menu = false;
    }, 99);
    setTimeout(() => {
      menu = true;
    }, 100);
  }
}
window.retourMenu = retourMenu;



























const screenRatio = window.innerWidth / window.innerHeight;
let _isPCSupportive = false;
isPCSupportive();


// Fonction pour tester la puissance du PC
function isPCSupportive() {
  const memory = navigator.deviceMemory || 4;  // RAM en Go
  const cores = navigator.hardwareConcurrency || 2;  // Nombre de cœurs

  const start = performance.now();
  let frameCount = 0;

  function testPerformance() {
    frameCount++;
    const now = performance.now();
    if (now - start < 1000) {
      requestAnimationFrame(testPerformance);
    } else {
      const fps = frameCount;
      const isSupportive = fps >= 20 && memory >= 4 && cores >= 2;
      _isPCSupportive = isSupportive;
    }
  } 

  testPerformance();  // Commencer le test
}


  
let mouse_click = 0;
document.addEventListener("mousedown", () => {
  mouse_click = -1
});

document.addEventListener("mouseup", () => {
  mouse_click = 2
});

// Tableau pour stocker les positions initiales des particules
if (!particleGeometry.attributes.initialPosition) {
    let initialPositions = new Float32Array(particleCount * 3);
    for (let i = 0; i < particleCount; i++) {
        initialPositions[i * 3] = particleGeometry.attributes.position.getX(i);
        initialPositions[i * 3 + 1] = particleGeometry.attributes.position.getY(i);
        initialPositions[i * 3 + 2] = particleGeometry.attributes.position.getZ(i);
    }
    particleGeometry.setAttribute('initialPosition', new THREE.BufferAttribute(initialPositions, 3));
}

function distortParticles() {
  if (_isPCSupportive) {
    if (!window.matchMedia("(pointer: coarse)").matches) {
      const mouseScreenPos = new THREE.Vector2(mouse.x, mouse.y);

      for (let i = 0; i < particleCount; i++) {
          // Récupérer la position initiale en espace monde
          let initialWorldPos = new THREE.Vector3(
              particleGeometry.attributes.initialPosition.getX(i),
              particleGeometry.attributes.initialPosition.getY(i),
              particleGeometry.attributes.initialPosition.getZ(i)
          );

          // Transformer en espace local (inverse de `particles.matrixWorld`)
          let inverseMatrix = new THREE.Matrix4().copy(particles.matrixWorld).invert();
          let initialLocalPos = initialWorldPos.clone().applyMatrix4(inverseMatrix);

          // Récupérer la position actuelle
          let particle = new THREE.Vector3(
              particleGeometry.attributes.position.getX(i),
              particleGeometry.attributes.position.getY(i),
              particleGeometry.attributes.position.getZ(i)
          ).applyMatrix4(particles.matrixWorld); // Passer en espace monde

          // Convertir en coordonnées écran
          let screenPos = particle.clone().project(camera);
          let screenParticlePos = new THREE.Vector2(screenPos.x, screenPos.y);

          // Calculer le vecteur direction souris -> particule
          let displacementVector = new THREE.Vector2().subVectors(screenParticlePos, mouseScreenPos);
          displacementVector.x *= screenRatio;
          let distanceToMouse = displacementVector.length();

          if (distanceToMouse < 0.2 + mouse_click/10) {  
              displacementVector.normalize();
              let displacement = (0.2 + mouse_click/10 - distanceToMouse) * 0.3 ; // Force de déplacement

              // Déplacement perpendiculaire à la caméra
              let displacement3D = new THREE.Vector3(displacementVector.x, displacementVector.y, 0);
              displacement3D.applyMatrix4(camera.matrixWorld);
              displacement3D.sub(camera.position).normalize().multiplyScalar(displacement);

              // Appliquer le déplacement
              particle.add(displacement3D);
          }

          // Effet de retour élastique vers la position initiale
          let springFactor = 0.05;

          // Si tu utilises Three.js, tu peux créer une matrice de rotation et appliquer la rotation.
          const rotationMatrix = new THREE.Matrix4();
          rotationMatrix.makeRotationZ(particles.rotation.z); // rotation autour de l'axe Z

          // Appliquer la matrice de rotation sur la position initiale.
          const rotatedPosition = initialWorldPos.clone().applyMatrix4(rotationMatrix);

          const particleOffset = new THREE.Vector3(0, 0, 0);
          // Maintenant, tu peux utiliser cette position dans ton calcul de currentWorldPos.
          const currentWorldPos = rotatedPosition.add(particleOffset);

          // Appliquer l'interpolation avec la nouvelle position.
          particle.lerp(currentWorldPos, springFactor);

          // Transformer en espace local et mettre à jour la géométrie
          let particleLocalPos = particle.applyMatrix4(inverseMatrix);
          particleGeometry.attributes.position.setXYZ(i, particleLocalPos.x, particleLocalPos.y, particleLocalPos.z);
      }

      particleGeometry.attributes.position.needsUpdate = true;
      
    }
  }
}





function initialPositions3_chepatropquand(){
  if (!particleGeometry3) {
    console.warn("particleGeometry3 n'est pas initialisé correctement ou ses attributs sont manquants.");
  }

  // Créer un tableau pour stocker les positions initiales des particules (pour particles3)
  if (!particleGeometry3.attributes.initialPosition) {
    let initialPositions3 = new Float32Array(particleCount * 3);
    for (let i = 0; i < particleCount; i++) {
      initialPositions3[i * 3] = particleGeometry3.attributes.position.getX(i);
      initialPositions3[i * 3 + 1] = particleGeometry3.attributes.position.getY(i);
      initialPositions3[i * 3 + 2] = particleGeometry3.attributes.position.getZ(i);
    }
    particleGeometry3.setAttribute('initialPosition', new THREE.BufferAttribute(initialPositions3, 3));
  }
}

function distortParticles3() {
  if (_isPCSupportive) {
    const mouseScreenPos3 = new THREE.Vector2(mouse.x, mouse.y);

    for (let i = 0; i < particleCount; i++) {
      // Récupérer la position initiale en espace monde
      let initialWorldPos3 = new THREE.Vector3(
        particleGeometry3.attributes.initialPosition.getX(i),
        particleGeometry3.attributes.initialPosition.getY(i),
        particleGeometry3.attributes.initialPosition.getZ(i)
      );

      // Transformer en espace local (inverse de `particles3.matrixWorld`)
      let inverseMatrix3 = new THREE.Matrix4().copy(particles3.matrixWorld).invert();
      let initialLocalPos3 = initialWorldPos3.clone().applyMatrix4(inverseMatrix3);

      // Récupérer la position actuelle
      let particle3 = new THREE.Vector3(
        particleGeometry3.attributes.position.getX(i),
        particleGeometry3.attributes.position.getY(i),
        particleGeometry3.attributes.position.getZ(i)
      ).applyMatrix4(particles3.matrixWorld); // Passer en espace monde

      // Convertir en coordonnées écran
      let screenPos3 = particle3.clone().project(camera);
      let screenParticlePos3 = new THREE.Vector2(screenPos3.x, screenPos3.y);

      // Calculer le vecteur direction souris -> particule
      let displacementVector3 = new THREE.Vector2().subVectors(screenParticlePos3, mouseScreenPos3);
      displacementVector3.x *= screenRatio;
      let distanceToMouse3 = displacementVector3.length();

      if (distanceToMouse3 < 0.2 + mouse_click/10) {
        displacementVector3.normalize();
        let displacement3 = (0.2 + mouse_click/10 - distanceToMouse3) * 0.3; // Force de déplacement

        // Déplacement perpendiculaire à la caméra
        let displacement3D3 = new THREE.Vector3(displacementVector3.x, displacementVector3.y, 0);
        displacement3D3.applyMatrix4(camera.matrixWorld);
        displacement3D3.sub(camera.position).normalize().multiplyScalar(displacement3);

        // Appliquer le déplacement
        particle3.add(displacement3D3);
      }

      // Effet de retour élastique vers la position initiale
      let springFactor3 = 0.05;

      // Créer la matrice de rotation pour cette particule (rotation autour de l'axe Z)
      const rotationMatrix3 = new THREE.Matrix4();
      rotationMatrix3.makeRotationZ(particles3.rotation.z);

      // Appliquer la matrice de rotation sur la position initiale
      const rotatedPosition3 = initialWorldPos3.clone().applyMatrix4(rotationMatrix3);

      const particleOffset3 = new THREE.Vector3(0, 0, 0); // Décalage supplémentaire si nécessaire
      const currentWorldPos3 = rotatedPosition3.add(particleOffset3);

      // Appliquer l'interpolation avec la nouvelle position
      particle3.lerp(currentWorldPos3, springFactor3);

      // Transformer en espace local et mettre à jour la géométrie
      let particleLocalPos3 = particle3.applyMatrix4(inverseMatrix3);
      particleGeometry3.attributes.position.setXYZ(i, particleLocalPos3.x, particleLocalPos3.y, particleLocalPos3.z);
    }

    // Marquer la géométrie comme mise à jour
    particleGeometry3.attributes.position.needsUpdate = true;
  }
}


document.addEventListener('DOMContentLoaded', () => {animate()});
//animate();
console.log("script charged");





